<style lang="scss" scoped>
.create-form-contract {
  width: 100%;

  .form-group {
    margin-bottom: 0px;
  }

  .form-field {
    margin-bottom: 15px;
  }

  label {
    font-weight: 600;
  }

  .contract-left {
    float: left;
    width: 50%;
  }

  .required {
    color: #ff1a1a;
  }

  .contract-right {
    float: right;
    width: 50%;
  }

  .add-contract {
    clear: both;
    margin-left: 14px;
  }

  .information-contract {
    position: relative;
    clear: both;

    .form-field {
      float: left;
    }

    .delete-employee {
      position: absolute;
      display: block;
      right: 9%;
      top: 34px;
    }
  }

  .require {
    color: #ff1a1a;
  }

  .btn-add-employee {
    clear: both;
    margin-left: 14px;

    .btn-add-new label {
      color: #f6ab5f;
      font-size: 1rem;
      cursor: pointer;
    }
  }

  .contract.button {
    clear: both;

    .save-contract {
      background: #b4daf3;
      font-weight: 600;
      padding: 7px 70px;
      color: #0d2e48;
      margin: 40px 14px 0px;
      border: 2px solid #b4daf3;
    }

    .cancel-contract {
      margin-top: 40px;
      padding: 7px 45px;
      font-weight: 600;
      background: #f6f6f6;
      border: 2px solid #0d2e48;
      color: #0d2e48;
      max-width: 300px;
    }
  }
}

@media screen and (max-width: 767px) {
  .container-fluid {
    .contract.container {
      padding: 0;
      .create-form-contract {
        margin-right: 0px;

        .save-contract {
          width: 100%;
          margin: 2.5rem 0 0 0;
        }

        .cancel-contract {
          width: 100%;
          max-width: 100%;
          margin: 0.625rem 0 1rem 0;
        }

        .contract-left {
          clear: both;
          width: 100%;
        }

        .contract-right {
          clear: both;
          width: 100%;
        }

        .information-employee {
          .delete-employee {
            right: 0%;
          }
        }
        .form-field-mobile {
          padding: 0;
        }
        .add-contract,
        .btn-add-employee {
          margin: 180px 0 0 0;
        }
        .contract-button-mobile {
          display: block !important;
        }
        .form-field {
          padding: 0;
        }
      }
    }
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .contract.container {
    max-width: 100%;
  }
}
</style>
<template>
  <CContainer class="contract">
    <ValidationObserver ref="formCreateContract" v-slot="{ handleSubmit }">
      <CForm
        class="create-form-contract"
        @submit.prevent="handleSubmit(submitContract)"
      >
        <CCol md="12 form-field-mobile">
          <CCol md="10" sm="12" class="form-field form-field-mobile">
            <h4>{{ $t("contract.create_contract") }}</h4>
          </CCol>
        </CCol>
        <CCol md="12" class="contract-left form-field-mobile">
          <CCol md="10" sm="12" class="form-field form-field-mobile">
            <label>
              {{ $t("employee.code_employee") }}
            </label>
            <CInput type="text" :disabled="true" :value="form.employee_id" />
          </CCol>
        </CCol>
        <CCol md="12" class="contract-right form-field-mobile">
          <CCol md="10" sm="12" class="form-field form-field-mobile">
            <label>
              {{ $t("placeholder.label_employee_search_name") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('placeholder.label_employee_search_name')"
            >
              <Select2
                class="select2-custom"
                v-model="form.employee_id"
                :options="employee_list"
              />
              <span class="required">{{ $t(errors[0]) }}</span>
            </ValidationProvider>
          </CCol>
        </CCol>
        <CCol md="12" sm="12" class="form-field add-contract form-field-mobile">
          <h4>{{ $t("contract.add_contract") }}</h4>
        </CCol>
        <CCol md="12 form-field-mobile">
          <div
            v-for="(item, index) in addContract"
            :key="index"
            class="customer-information"
          >
            <div class="information-contract">
              <CCol md="4" class="form-field form-field-mobile">
                <label>
                  {{ $t("contract.type_contract") }}
                  <span class="require">*</span>
                </label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="
                    $t('contract.type_contract_position') +
                      ' ' +
                      getNumberRow(index)
                  "
                >
                  <select
                    class="form-control form-group"
                    v-model="form.employee_contract[index].contract_code"
                  >
                    <option value="">{{ $t("employee.select_option") }}</option>
                    <option
                      v-for="(option, index) in contracts"
                      :key="index"
                      :value="option.code"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                  <span class="required">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </CCol>
              <CCol md="3" class="form-field form-field-mobile">
                <label>
                  {{ $t("additional_timeSheet.start_date") }}
                  <span class="require">*</span>
                </label>
                <ValidationProvider
                  :rules="{
                    required: true,
                    check_format_start_date: true,
                    less_end_time: {
                      end_date: form.employee_contract[index].end_date
                    }
                  }"
                  v-slot="{ errors }"
                  :name="
                    $t('contract.position_start_date') +
                      ' ' +
                      getNumberRow(index)
                  "
                >
                  <DatePickerFormFlex
                    :propsDate="form.employee_contract[index].start_date"
                    @emitDate="startDate($event, index)"
                    v-model="form.employee_contract[index].start_date"
                  />
                  <span class="required">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </CCol>
              <CCol md="3" class="form-field form-field-mobile">
                <label>
                  {{ $t("additional_timeSheet.end_date") }}
                </label>
                <ValidationProvider
                  :rules="{
                    fewer_start_time: {
                      start_date: form.employee_contract[index].start_date
                    },
                    check_format_end_date: true
                  }"
                  v-slot="{ errors }"
                  :name="$t('additional_timeSheet.end_date')"
                >
                  <DatePickerFormFlex
                    :propsDate="form.employee_contract[index].end_date"
                    @emitDate="endDate($event, index)"
                    v-model="form.employee_contract[index].end_date"
                  />
                  <span class="required">{{ $t(errors[0]) }}</span>
                </ValidationProvider>
              </CCol>
              <span
                class="delete-employee"
                @click="deleteContract(index)"
                v-if="form.employee_contract.length > 1"
              >
                <CIcon name="cilTrash" class="delete-btn" />
              </span>
            </div>
          </div>
        </CCol>
        <CCol md="10" sm="12" class="form-field btn-add-employee">
          <div class="btn-add-new ">
            <label @click="addEmployeeContract()"
              >+ {{ $t("contract.add_contract") }}</label
            >
          </div>
        </CCol>
        <CCol
          md="12"
          sm="12"
          class="contract button d-flex justify-content-start contract-button-mobile"
        >
          <CButton type="submit" class="save-contract"
            >{{ $t("label.save_infomation") }}
          </CButton>
          <CButton class="cancel-contract" type="button" @click="cancel()"
            >{{ $t("contract.cancel_contract") }}
          </CButton>
        </CCol>
      </CForm>
    </ValidationObserver>
  </CContainer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_contract_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },

  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerFormFlex
  },

  async created() {
    await this.$store.dispatch("contract-employee/getCommonsData");
  },

  computed: {
    ...mapGetters({
      employees: "contract-employee/employees",
      contracts: "contract-employee/contracts"
    })
  },

  data() {
    return {
      
      addContract: [0],
      employee_list: [],
      form: {
        employee_id: "",
        employee_contract: [
          {
            contract_code: "",
            start_date: Intl.DateTimeFormat("en-GB").format(new Date()),
            end_date: Intl.DateTimeFormat("en-GB").format(new Date())
          }
        ]
      }
    };
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),

    startDate(data, index) {
      this.form.employee_contract[index].start_date = data;
    },

    endDate(data, index) {
      this.form.employee_contract[index].end_date = data;
    },

    async submitContract() {
      this.setLoading(true);
      await this.$store
        .dispatch("contract-employee/createContractEmployee", this.form)
        .then(() => {
          let message = this.$t("contract.popup.create_contract_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: "/contracts" });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },

    getNumberRow(index) {
      return index + 1;
    },

    addEmployeeContract() {
      this.addContract.push(this.addContract.length);
      let size = 0;
      size = this.form.employee_contract.length;
      this.form.employee_contract[size] = {
        contract_code: "",
        start_date: Intl.DateTimeFormat("en-GB").format(new Date()),
        end_date: Intl.DateTimeFormat("en-GB").format(new Date())
      };
    },

    deleteContract(index) {
      this.addContract.splice(index, 1);
      this.form.employee_contract.splice(index, 1);
    },

    cancel() {
      this.$confirm(
        this.$t("contract.cancel_contract"),
        this.$t("popup.employee.label_popup_title"),
        this.$t("popup.employee.label_confirm_button"),
        this.$t("popup.employee.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$router.push({ path: "/contracts" });
        }
      });
    }
  },

  watch: {
    employees(employeeList) {
      this.employee_list = employeeList.map((employee)=> { 
        let splitSpaceString = employee.text.split(" ");
        let newStringEmail = splitSpaceString[splitSpaceString.length-1];
        let newStringName = splitSpaceString[splitSpaceString.length-2];
        let newArray = ((splitSpaceString.slice(0, splitSpaceString.length-2)).map(([i]) =>i)).join('');
        let numberPattern = /\d+/g;
        if(newStringEmail.match(numberPattern)=== null){
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + ")"
          }
        }
        else {
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + newStringEmail.match(numberPattern) + ")"
          }
        }
      })
    }
  }
};
</script>

<style>
.delete-btn {
  color: red;
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

.select2-container {
  width: 100% !important;
}
</style>
